export const ETHNIC_APPEARANCES = {
  MAX: 4,
  MIN_LENGTH: 1,
};

export default ETHNIC_APPEARANCES;
